import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const formatStatus = (t: (key: string) => string, status?: string | null) => {
  if (!status) {
    return <p className="activeStatus">{t('functions.statuses.undefined')}</p>;
  }
  switch (status) {
    case 'active':
      return <p className="activeStatus">{t('functions.statuses.active')}</p>;
    case 'canceled':
      return <p className="deactivatedStatus">{t('functions.statuses.canceled')}</p>;
    case 'approved':
      return <p className="activeStatus">{t('functions.statuses.approved')}</p>;
    case 'verified':
      return <p className="activeStatus">{t('functions.statuses.verified')}</p>;
    case 'notBlocked':
      return <p className="activeStatus">{t('functions.statuses.notBlocked')}</p>;
    case 'deactivated':
      return <p className="deactivatedStatus">{t('functions.statuses.deactivated')}</p>;
    case 'removed':
      return <p className="deactivatedStatus">{t('functions.statuses.removed')}</p>;
    case 'expired':
      return <p className="deactivatedStatus">{t('functions.statuses.expired')}</p>;
    case 'blocked':
      return <p className="deactivatedStatus">{t('functions.statuses.blocked')}</p>;
    case 'pending':
      return <p className="pendingStatus">{t('functions.statuses.pending')}</p>;
    case 'notVerified':
      return <p className="pendingStatus">{t('functions.statuses.notVerified')}</p>;
    default:
      return <p className="unknownStatus">{status}</p>;
  }
};

function useDebounce<T>(value: T, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;

export const formatPlanName = (t: (key: string) => string, singleFlight: boolean, family: boolean, periodInMonths?: number) => {
  try {
    const planType = family ? t('promoCode.formatPlanName.familyPlan') : t('promoCode.formatPlanName.soloPlan');

    const name = singleFlight ? t('promoCode.formatPlanName.single') + ` - ${planType}` : `${periodInMonths}` + t('promoCode.formatPlanName.month') + ` - ${planType}`;
    return name;
  } catch (e) {
    console.error(e);
    return '';
  }
};
